import { GuestUser } from "components/types/Api";
import { ContextProviderProps } from "components/types/Context";
import { User, initialUser } from "components/types/types";
import { Dispatch, SetStateAction, createContext, useContext, useEffect, useState } from "react";



const initialGuestUser: GuestUser = {
    firstName: "",
    lastName: "",
    email: "",
    city: {
        value: "",
        label: "",
        htmlDescription: undefined
    },
    companyName: ""
}

export type GuestContextType = {
    userGuest?: GuestUser
    setUserGuest: Dispatch<SetStateAction<GuestUser | undefined>>
    updateGuestUser: (fieldsToUpdate: Partial<GuestUser>) => void
    canMatch?: boolean,
    setCanMatch: Dispatch<SetStateAction<boolean | undefined>>,
    resetGuest: (storage?: boolean) => void
}

export const GuestContext = createContext<GuestContextType>({
    userGuest: undefined,
    setUserGuest: () => { },
    updateGuestUser: (fieldsToUpdate: Partial<GuestUser>) => { },
    canMatch: undefined,
    setCanMatch: () => { },
    resetGuest: () => { }
})

const GuestContextProvider = ({ children }: ContextProviderProps) => {
    const [userGuest, setUserGuest] = useState<GuestUser | undefined>()
    const [canMatch, setCanMatch] = useState<boolean | undefined>()

    const updateGuestUser = (fieldsToUpdate: Partial<GuestUser>) => {
        if (userGuest) {
            let update: GuestUser = { ...userGuest, ...fieldsToUpdate }
            setUserGuest(update)
        } else {
            let update: GuestUser = { ...initialGuestUser, ...fieldsToUpdate }
            setUserGuest(update)
        }
    }



    function resetGuest(storage?: boolean) {
        setUserGuest(undefined);
        if (storage) {
            localStorage.removeItem("userGuest")
        }

    }



    const guestCtx: GuestContextType = {
        userGuest, setUserGuest, updateGuestUser,
        canMatch, setCanMatch,
        resetGuest

    }

    return (
        <GuestContext.Provider value={guestCtx}>
            {children}
        </GuestContext.Provider>
    )
}

const useGuestView = () => useContext(GuestContext)

export { GuestContextProvider, useGuestView }